import React from 'react';
import { Film, MoreHorizontal, Video } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export interface FormatProfileCardProps {
  id: string;
  formatName: string;
  brandName: string;
  description: string;
  duration: string;
  style: string;
  keyElements: string[];
  swipefileReferences: Array<{
    id: string;
    title: string;
    thumbnail: string;
  }>;
  onEdit?: (id: string) => void;
}
export function FormatProfileCard({
  id,
  formatName,
  brandName,
  description,
  duration,
  style,
  keyElements,
  swipefileReferences,
  onEdit
}: FormatProfileCardProps) {
  return <Card className="border-gray-200 hover:shadow-lg transition-all duration-300 bg-white" data-id="element-437">
      <CardContent className="p-6" data-id="element-438">
        {/* Header */}
        <div className="flex items-start justify-between mb-4" data-id="element-439">
          <div className="flex items-center gap-3" data-id="element-440">
            <div className="h-12 w-12 rounded-lg bg-purple-500/10 flex items-center justify-center" data-id="element-441">
              <Film className="h-6 w-6 text-purple-600" data-id="element-442" />
            </div>
            <div data-id="element-443">
              <h3 className="font-bold text-lg text-gray-900" data-id="element-444">{formatName}</h3>
              <Badge variant="outline" className="text-xs border-[#139191]/30 bg-[#139191]/5 text-[#139191] mt-1" data-id="element-445">
                {brandName}
              </Badge>
            </div>
          </div>
          <Button variant="ghost" size="icon" className="h-8 w-8 text-gray-400 hover:text-gray-600" data-id="element-446">
            <MoreHorizontal className="h-4 w-4" data-id="element-447" />
          </Button>
        </div>

        {/* Details */}
        <div className="space-y-3 mb-4" data-id="element-448">
          <p className="text-sm text-gray-600" data-id="element-449">{description}</p>
          <div className="flex gap-3" data-id="element-450">
            <div data-id="element-451">
              <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-452">
                Duration
              </p>
              <Badge variant="outline" className="text-xs border-gray-200 bg-gray-50" data-id="element-453">
                {duration}
              </Badge>
            </div>
            <div data-id="element-454">
              <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-455">Style</p>
              <Badge variant="outline" className="text-xs border-gray-200 bg-gray-50" data-id="element-456">
                {style}
              </Badge>
            </div>
          </div>
          <div data-id="element-457">
            <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-458">
              Key Elements
            </p>
            <div className="flex flex-wrap gap-1.5" data-id="element-459">
              {keyElements.map((element, idx) => <Badge key={idx} variant="outline" className="text-xs border-gray-200 bg-gray-50" data-id="element-460">
                  {element}
                </Badge>)}
            </div>
          </div>
        </div>

        {/* Swipefile References */}
        <div className="pt-4 border-t border-gray-100" data-id="element-461">
          <div className="flex items-center justify-between mb-3" data-id="element-462">
            <p className="text-xs font-semibold text-gray-700 flex items-center gap-1.5" data-id="element-463">
              <Video className="h-3.5 w-3.5 text-purple-600" data-id="element-464" />
              Swipefile References ({swipefileReferences.length})
            </p>
          </div>
          <div className="grid grid-cols-3 gap-2" data-id="element-465">
            {swipefileReferences.slice(0, 3).map(ref => <div key={ref.id} className="relative bg-gray-100 rounded overflow-hidden" style={{
            aspectRatio: '9/16'
          }} data-id="element-466">
                <img src={ref.thumbnail} alt={ref.title} className="w-full h-full object-cover" data-id="element-467" />
              </div>)}
          </div>
          {swipefileReferences.length > 3 && <p className="text-xs text-gray-500 mt-2" data-id="element-468">
              +{swipefileReferences.length - 3} more
            </p>}
        </div>

        {/* Actions */}
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-469">
          <Button variant="outline" size="sm" className="w-full border-gray-200 hover:border-purple-600 hover:text-purple-600" onClick={() => onEdit?.(id)} data-id="element-470">
            Edit Format
          </Button>
        </div>
      </CardContent>
    </Card>;
}